
import { Link } from 'react-router-dom';
import './App.css';
import Board from './Pages/Board';
import backgroundVideo from  './backgroundsea.mp4';
import { IconName,GiOysterPearl } from "react-icons/gi";


function App() {
  return (
  <>
    <video autoPlay loop muted id='video'>
      <source src={backgroundVideo} type='video/mp4'/>
      
       </video>
    <div className="App">
      <header  className="App-header navbar m-3 ">
       <h1 className = "heading fst-italic fw-bold shadow rounded-pill p-3">Welcome to Pearl Play <GiOysterPearl /></h1>
      </header>
<Board/>
      <footer>
      <div>
    
    <span className='text-warning'>Thanks for visiting &copy; 2023 Pearl Play</span>
  </div>
  <div>
    <span className='text-warning'>Design & Developed by  <a className='text-warning' target='_blank'
            rel='noopener noreferrer' href="https://www.linkedin.com/in/laxmiav/">Muthulakshmi</a>
   </span>
    
   
  </div>

      </footer>

    </div>
  
  </>
  );
}

export default App;
